import SpriteSymbol from "../../../../../../../../root/.zend/plugin/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../root/.zend/plugin/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ArrowRightOutlined",
  "use": "ArrowRightOutlined-usage",
  "viewBox": "64 64 896 896",
  "content": "<symbol viewBox=\"64 64 896 896\" id=\"ArrowRightOutlined\"><path d=\"M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol